
import Typography from '@/ui-kit/components/typography';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';
import {
  StyleSizeType,
  StylePositionType,
  StyleColorSchemeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import Button from '@/ui-kit/components/button';
import { ButtonProperty, ButtonType, ButtonFillType } from '@/ui-kit/components/button/enums';
import BaseImage from '@/ui-kit/components/image';
import { ImageProperty } from '@/ui-kit/components/image/enums';
import WindowSize from '@/ui-kit/mixins/windowSize';
import { STYLES_BY_ROUTE } from './constants';

export default {
  name: 'InfoBoxNew',
  components: {
    Typography,
    Button,
    BaseImage,
  },
  mixins: [WindowSize],
  props: {
    heroImages: {
      default: () => ({}),
      type: Object,
    },
    heroTitle: {
      default: () => ({}),
      type: Object,
    },
    heroSubHeader: {
      default: () => ({}),
      type: Object,
    },
    heroText: {
      default: () => ({}),
      type: Object,
    },
    heroButton: {
      default: () => ({}),
      type: Object,
    },
    trackEvent: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TypographyProperty,
      TypographyType,
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      StyleFontWeightType,
      ButtonProperty,
      ButtonType,
      ButtonFillType,
      ImageProperty,
    };
  },
  computed: {
    imageArray() {
      return [
        this.heroImages.hero_image,
        this.heroImages.listing_card_1,
        this.heroImages.listing_card_2,
        this.heroImages.single_pie_chart,
        this.heroImages.dual_donut_chart,
        this.heroImages.single_bar_chart,
        this.heroImages.tiny_bar_chart,
      ];
    },
    imageStyles() {
      return STYLES_BY_ROUTE[this.$route.path];
    },
    imageStyleProperties() {
      return this.imageStyles.map((item) => `
        width: ${item.width};
        height: ${item.height};
        top: ${item.top ? item.top : ''};
        right: ${item.right ? item.right : ''};
        bottom: ${item.bottom ? item.bottom : ''};
        z-index: ${item.zIndex};
        transform: ${item.scale ? `scale(${item.scale})` : ''};
      `);
    },
    buttonFillType() {
      return this.isSmallerThan(StyleSizeType.Large)
        ? ButtonFillType.Underlined
        : ButtonFillType.Text;
    },
  },
};
